import React, { useState, useEffect } from 'react';
import { TableContainer, Paper, Tabs, Tab, Box } from '@mui/material';
import BookableTab from './BookableTab';
import IssuableTab from './IssuableTab';
import PurchasableTab from './PurchasableTab';
import WorkbenchBookingsTab from './WorkbenchBookingsTab';
import { useSelector } from 'react-redux';

const RecordsTable = ({ activeTab: initialActiveTab }) => {
    const [activeTab, setActiveTab] = useState(initialActiveTab);
    const { user } = useSelector((state) => state.user);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        setActiveTab(initialActiveTab);  // Set the initial tab based on the prop
    }, [initialActiveTab]);

    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                paddingBottom: '4px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    padding: '0.25rem',
                    paddingBottom: '0px',
                    overflowX: 'auto',  
                }}
            >
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="none"
                    textColor="rgb(39,63,119)"
                    sx={{
                        padding: '5px',
                        height: 'auto',
                        background: 'rgb(242,243,252)',
                        border: '2px solid rgba(39,63,119,0.6)',
                        borderRadius: '12px',
                        marginBottom: '10px',
                        minWidth: 0,  // Ensure tabs can shrink
                        '& .MuiTabs-flexContainer': {
                            gap: '2px',  // Tighter gap for smaller screens
                        },
                        '@media (max-width:600px)': {
                            background: 'transparent',
                            border: 'none',
                            padding: 0,
                        },
                    }}
                >
                    <Tab
                        label="Reservations" //Machines -> Not Workbench
                        sx={{
                            padding: '8px 32px',
                            height: '44px',
                            typography: 'body1',
                            fontWeight: '600',
                            border: '2px solid rgba(39,63,119,0.6)',
                            borderRadius: '8px',
                            marginRight: 0,
                            '&.Mui-selected': {
                                background: 'rgb(39,63,119)',
                                color: 'white',
                            },
                            /* MOBILE ONLY */
                            '@media (max-width:600px)': {
                                border: 'none',
                                padding: '4px 6px',  
                                height: '36px',  
                                '&.Mui-selected': {
                                    background: 'transparent',
                                    color: 'rgb(39,63,119)',
                                    border: '2px solid rgb(39,63,119)',
                                    borderRadius: '20px',
                                    padding: '4px 10px',  
                                },
                            },
                        }}
                    />
                    <Tab
                        label="Issuable"
                        sx={{
                            padding: '8px 32px',
                            height: '44px',
                            typography: 'body1',
                            fontWeight: '600',
                            border: '2px solid rgba(39,63,119,0.6)',
                            borderRadius: '8px',
                            marginRight: 0,
                            '&.Mui-selected': {
                                background: 'rgb(39,63,119)',
                                color: 'white',
                            },
                            '@media (max-width:600px)': {
                                border: 'none',
                                padding: '4px 6px',  
                                height: '36px',  
                                '&.Mui-selected': {
                                    background: 'transparent',
                                    color: 'rgb(39,63,119)',
                                    border: '2px solid rgb(39,63,119)',
                                    borderRadius: '20px',
                                    padding: '4px 10px',  
                                },
                            },
                        }}
                    />
                    <Tab
                        label="Purchasable"
                        sx={{
                            padding: '8px 32px',
                            height: '44px',
                            typography: 'body1',
                            fontWeight: '600',
                            border: '2px solid rgba(39,63,119,0.6)',
                            borderRadius: '8px',
                            marginRight: 0,
                            '&.Mui-selected': {
                                background: 'rgb(39,63,119)',
                                color: 'white',
                            },
                            '@media (max-width:600px)': {
                                border: 'none',
                                padding: '4px 6px',  
                                height: '36px',  
                                '&.Mui-selected': {
                                    background: 'transparent',
                                    color: 'rgb(39,63,119)',
                                    border: '2px solid rgb(39,63,119)',
                                    borderRadius: '20px',
                                    padding: '4px 10px',  
                                },
                            },
                        }}
                    />
                </Tabs>
            </Box>
            <Box sx={{ flexGrow: 1, overflow: 'auto', paddingInline: '1rem' }}>
                {activeTab === 0 && <BookableTab user={user} />}
                {activeTab === 1 && <IssuableTab user={user} />}
                {activeTab === 2 && <PurchasableTab user={user} />}
                {activeTab === 3 && <WorkbenchBookingsTab user={user} />}
            </Box>
        </TableContainer>
    );
};

export default RecordsTable;